import axios from 'axios';
import analytics from 'utils/segment';
import { toast } from 'react-toastify';
import { atlasColorTokens } from 'theme/tokens';
import { fetchFromIpApi } from 'utils/geolocation';

export interface SlackMessage {
	title: string;
	details: string;
	address?: string;
}

export const sendSlackMessage = async (
	webhookUrl: string,
	agent: string = 'ATLAS',
	status: 'success' | 'error',
	message: SlackMessage,
): Promise<void> => {
	if (!webhookUrl) {
		return;
	}

	const color =
		status === 'success'
			? atlasColorTokens.dark.slack.success
			: atlasColorTokens.dark.slack.error;

	let locationInfo = null;
	try {
		locationInfo = await fetchFromIpApi();
	} catch {
		//
	}

	const na = 'N/A';
	const location =
		[locationInfo?.city, locationInfo?.region, locationInfo?.country]
			.filter(Boolean)
			.join(', ') || na;

	const fields = [
		{ title: 'Event', value: message.title, short: false },
		{ title: 'Message', value: message.details, short: false },
		{ title: 'Address', value: message.address || na, short: false },
		{ title: 'IP Address', value: locationInfo?.ip || na, short: true },
		{ title: 'Location', value: location, short: true },
		{
			title: 'Country Code',
			value: locationInfo?.countryCode || na,
			short: true,
		},
		{ title: 'Domain', value: window.location.origin, short: true },
	];

	const payload = {
		url: webhookUrl,
		text: `*${agent}*`,
		attachments: [{ color, fields }],
	};

	try {
		const isAtlasDomain =
			typeof window !== 'undefined' &&
			(window.location.origin === 'https://atlas.rndm.io' ||
				window.location.origin ===
					'https://atlas-defi-demo-git-ak-delta-neutral-vcred.vercel.app');

		if (isAtlasDomain) {
			await axios.post('https://slack-ydfb.vercel.app/', payload, {
				headers: { 'Content-Type': 'application/json' },
				timeout: 8000,
			});
			analytics.track(message.title, {
				...message,
				ip: locationInfo?.ip,
			});
		}

		if (status === 'success' && message.details) {
			toast.success(message.details, { autoClose: 5000 });
		} else if (status === 'error' && message.details) {
			toast.error(message.details, { autoClose: 5000 });
		}
	} catch {
		//
	}
};
